import './styles/FormError.scss';

interface Props {
  message: string;
}

export function FormError({ message }: Props) {
  return <p className="form-error">{message}</p>;
}
